import Dexie from 'dexie';

export const db = new Dexie('aviation-check');
db.version(1).stores({
  aircrafts: '++id, name, plate, created',
  checklists: '++id, name, aircraftId, order, nextchecklistId, danger',
  checks: '++id, name, value, aircraftId, checklistId, comment, order',
});
